import Vue from "vue";
import router from "../router";

export default {
  state: {
    id: null,
    nombre: "",
    clave: "",
    estatus: 1
  },
  mutations: {
    setCliente(state, cliente) {
      console.log(cliente);
      state.id = cliente.id;
      state.nombre = cliente.nombre;
      state.clave = cliente.clave;
      state.estatus = cliente.estatus;
      localStorage.id_cliente_imperia = cliente.id;
    }
  },
  actions: {
    DefinirCliente(context, cliente) {
      context.commit("setCliente", cliente);
      router.push({ name: "Login" });
    }
  },
  getters: {
    getCliente(state) {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/modules/cliente.js